import { ApiErrorCodeLabelModifier } from '@/api/error-codes';
import { LinkText, Table } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import type { BatchModel } from '../../_models/batch';

type Props = {
  errorDetails: NonNullable<
    NonNullable<
      z.infer<typeof BatchModel>['taskResult']['result']
    >['errorDetails']
  >;
};

export const BatchErrorDetails: FC<Props> = ({ errorDetails }) => {
  const { t } = useTranslation();

  return (
    <Table
      dataSource={errorDetails}
      rowKey="id"
      columns={[
        {
          title: t('batch.table-no'),
          render: (_text, _record, index) => index + 1,
          width: 50,
        },
        {
          title: t('batch.error-target'),
          key: 'name',
          dataIndex: 'name',
          render: (_, record) => {
            if (!record.id) {
              return record.name;
            }
            return (
              <LinkText
                text={record.name ?? ''}
                href={`/rs/project/${record.id}`}
              />
            );
          },
          width: 400,
        },
        {
          title: t('batch.error-message'),
          key: 'errorCode',
          dataIndex: 'errorCode',
          render: (value) => ApiErrorCodeLabelModifier[value],
          width: 400,
        },
      ]}
    />
  );
};
